<template>
  <b-modal
    id="equipment-employee-modal"
    title="Seleção de Pessoas"
    hide-footer
  >
    <h2 class="title">Gerencie as pessoas autorizadas a operar o equipamento</h2>
    <multiselect
      v-model="selectedEmployees"
      :options="employeesList"
      track-by="id"
      label="name"
      placeholder="Selecione ou digite para pesquisar por nome"
      selectLabel="Autorizar"
      deselectLabel="Remover autorização"
      selectedLabel="Autorizado"
      :searchable="true"
      :multiple="true"
      @select="handleSelected"
      @remove="handleRemoved"
    >
      <template #noResult>
        <span>Nome não encontrado.</span>
      </template>
      <template #noOptions>
        <span>Nenhuma opção carregada.</span>
      </template>
    </multiselect>

  </b-modal>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.title {
  font-size: 1.15rem;
  margin-bottom: 1rem;
}
</style>

<script>
import { DB_ROUTES } from '../../constants'
import { request } from '../../services'
import Multiselect from 'vue-multiselect'

export default {
  props: ['equipmentId'],
  components: {
    Multiselect
  },
  data () {
    return {
      selectedEmployees: [],
      employeesList: []
    }
  },
  watch: {
    equipmentId (newId) {
      this.fetchSelectedEmployees(newId)
    }
  },
  created () {
    this.fetchAllEmployees()
  },
  methods: {
    fetchSelectedEmployees (id) {
      request.get(
        DB_ROUTES.GET_EMPLOYEES_BY_EQUIPMENT(id),
        response => {
          if (response.status === 200) {
            // [{id, employeeId, equipmentId}, ...]
            this.selectedEmployees = response.data.map(item => ({
              id: item.employeeId,
              name: this.getEmployeeName(item.employeeId)
            }))
          } else {
            this.selectedEmployees = []
          }
        },
        error => console.log(error)
      )
    },
    fetchAllEmployees () {
      request.get(
        DB_ROUTES.GET_ALL_EMPLOYEES,
        response => {
          if (response.status === 200) {
            // [{id, name, ...}, ...]
            this.employeesList = response.data.map(item => ({
              id: item.id,
              name: item.name
            }))
          }
        },
        error => console.log(error)
      )
    },
    getEmployeeName (id) {
      const employee = this.employeesList.find(employee => employee.id === id)
      return employee?.name
    },
    handleSelected (selectedOption) {
      const body = {
        employeeId: selectedOption.id,
        equipmentId: this.equipmentId
      }
      request.post(
        DB_ROUTES.POST_EQUIPMENT_TO_EMPLOYEE,
        body,
        _ => {
          this.$bvToast.toast('Equipamento atualizado com sucesso!', {
            title: 'Sucesso',
            variant: 'success',
            solid: true
          })
        },
        error => {
          this.$bvToast.toast('Erro ao atualizar equipamento.', {
            title: 'Erro',
            variant: 'danger',
            solid: true
          })
          console.log(error)
        }
      )
    },
    handleRemoved (removedOption) {
      console.log('Removed option:', removedOption)
      alert('TODO: implement route to remove the employee from this equipment')
    }
  }
}
</script>
